var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseX = function SvgCloseX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.43.43a1.47 1.47 0 0 0-2.08 0L1.291 15.49a1.47 1.47 0 0 0 2.08 2.08L18.43 2.51a1.47 1.47 0 0 0 0-2.08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.291.43a1.47 1.47 0 0 1 2.08 0L18.43 15.49a1.47 1.47 0 1 1-2.08 2.08L1.291 2.51a1.47 1.47 0 0 1 0-2.08"
  })));
};
export default SvgCloseX;